import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Divider,
  Grid,
  Paper,
} from '@material-ui/core';
import SpecialProjectInfo from './SpecialProjectInfo';
import BookingFormProductTierInfo from './BookingFormProductTierInfo';
import BookingFormEmployeeInput from './BookingFormEmployeeInput';
import BookingFormHeader from './BookingFormHeader';
import BookingFormTwoItemRowInfo from './BookingFormTwoItemRowInfo';
import BookingFormInlineItemRowInfo from './BookingFormInlineItemRowInfo';

import i18n from '../../i18n';

import '../../assets/stylesheets/BookingForm.css';

class StudioForm extends Component {
  handleIconClick = event => {
    const { showEmployeesOfPosition, numberOfSet } = this.props;
    showEmployeesOfPosition(event.currentTarget.name, numberOfSet);
  };

  handleShowEmployeesOfPosition = position => {
    const { showEmployeesOfPosition, numberOfSet } = this.props;
    showEmployeesOfPosition(position, numberOfSet);
  };

  render() {
    const {
      handleSave,
      locationName,
      locationId,
      gender,
      info,
      inlineInfo,
      percentage,
      productTier,
      requiredPositions,
      setType,
      onFormEmployeeSelect,
      isSpecialProject,
      specialProject
    } = this.props;

    return (
      <Paper className="bookingForm">
        <Grid container spacing={0}>
          <BookingFormHeader
            locationId={locationId}
            locationName={locationName}
            handleSave={handleSave}
          />
          <BookingFormTwoItemRowInfo
            items={info}
          />

          <BookingFormInlineItemRowInfo
            label={inlineInfo.label}
            items={inlineInfo.items}
          />

          {gender && (
            <BookingFormTwoItemRowInfo
              items={[
                {
                  label: i18n.t('productCategoryL1'),
                  value: i18n.t(`booking:${gender}`)
                },
              ]}
              divider={false}
            />
          )}

          {percentage && (
            <BookingFormTwoItemRowInfo
              items={[
                {
                  label: i18n.t('booking:percentage'),
                  value: `${percentage} %`,
                },
              ]}
              divider={false}
            />
          )}
          <Grid item xs={12}>
            <Divider className="form-divider" />
          </Grid>
          {setType && (
            <BookingFormTwoItemRowInfo
              items={[
                {
                  label: i18n.t('booking:setType'),
                  value: setType
                }
              ]}
            />
          )}
          <BookingFormProductTierInfo productTier={productTier} />
          {isSpecialProject && (
            <SpecialProjectInfo specialProject={specialProject} />
          )}
          {requiredPositions.map((position, index) =>
            position.divider
            ?
              (
                // eslint-disable-next-line react/no-array-index-key
                <Grid key={`${position.positionTitle}-${index}`} item xs={12}>
                  <Divider className="form-divider" />
                </Grid>
              )
            :
              (
                <BookingFormEmployeeInput
                  key={position.positionTitle}
                  eligibleEmployees={position.eligibleEmployees}
                  onFormEmployeeSelect={onFormEmployeeSelect}
                  showEmployeesOfPosition={this.handleShowEmployeesOfPosition}
                  positionTitle={position.positionTitle}
                  label={position.positionLabel}
                />
              )
            )}
        </Grid>
      </Paper>
    );
  }
}

StudioForm.defaultProps = {
  specialProject: false,
  setType: null,
  percentage: null,
  gender: null,
};

StudioForm.propTypes = {
  gender: PropTypes.string,
  handleSave: PropTypes.func.isRequired,
  info: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  })).isRequired,
  inlineInfo: PropTypes.shape([PropTypes.string, PropTypes.arrayOf([PropTypes.string, PropTypes.number])]).isRequired,
  locationId: PropTypes.number.isRequired,
  locationName: PropTypes.string.isRequired,
  numberOfSet: PropTypes.string.isRequired,
  onFormEmployeeSelect: PropTypes.func.isRequired,
  percentage: PropTypes.string,
  productTier: PropTypes.number.isRequired,
  requiredPositions: PropTypes.arrayOf(PropTypes.object).isRequired,
  setType: PropTypes.string,
  showEmployeesOfPosition: PropTypes.func.isRequired,
  isSpecialProject: PropTypes.bool.isRequired,
  specialProject: PropTypes.oneOfType([
    PropTypes.shape([PropTypes.string, PropTypes.number]),
    PropTypes.bool
  ])
};

export default StudioForm;
